// src/features/scheduleBuilder/slices/publishHistoryEvents/constants.ts
export const SLICE_NAME = 'publishHistoryEvents';
export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule';
